import { SH1, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import LottieView from 'lottie-react-native'

const LeadCrossSellingRecommendationLoader = () => {
  return (
    <Stack className="mt-4 flex-1 items-center justify-center">
      <SH1 className="px-8 text-center">
        {i18n.t('crossSelling.suitableBrands')}
      </SH1>
      <LottieView
        autoPlay
        className="h-[200] w-full"
        source={require('../assets/lottie/CrossSellingSearch.json')}
      />
    </Stack>
  )
}

export default LeadCrossSellingRecommendationLoader
